var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCutIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    opacity: 0.368,
    width: 26,
    height: 26,
    transform: "translate(815 530)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "translate(-815 -530)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(649.98 -415.152) rotate(45)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    transform: "translate(788 547.8)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M 25.59959983825684 7.960400104522705 L 4.479300022125244 7.960400104522705 C 2.560309886932373 7.960400104522705 0.9991000294685364 6.399190425872803 0.9991000294685364 4.480200290679932 C 0.9991000294685364 2.56121039390564 2.560309886932373 1.000000238418579 4.479300022125244 1.000000238418579 C 5.815790176391602 1.000000238418579 7.050459861755371 1.780690312385559 7.624770164489746 2.98891019821167 L 7.896039962768555 3.559600353240967 L 8.52793025970459 3.559600353240967 L 30.90670967102051 3.559600353240967 C 30.43655014038086 6.061584949493408 28.23563385009766 7.960400104522705 25.59959983825684 7.960400104522705 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "none",
    d: "M 25.59959983825684 6.960400104522705 C 27.30619812011719 6.960400104522705 28.78893661499023 5.983635902404785 29.51833343505859 4.559600353240967 L 8.52793025970459 4.559600353240967 L 7.26416015625 4.559600353240967 L 6.721610069274902 3.41821026802063 C 6.312089920043945 2.556680202484131 5.431930065155029 2.000000238418579 4.479300022125244 2.000000238418579 C 3.111710071563721 2.000000238418579 1.999099969863892 3.112610340118408 1.999099969863892 4.480200290679932 C 1.999099969863892 5.847790241241455 3.111710071563721 6.960400104522705 4.479300022125244 6.960400104522705 L 25.59959983825684 6.960400104522705 M 25.59959983825684 8.960400581359863 L 4.479300022125244 8.960400581359863 C 2.005199909210205 8.960400581359863 -0.0008999969577416778 6.954300403594971 -0.0008999969577416778 4.480200290679932 C -0.0008999969577416778 2.006100177764893 2.005199909210205 2.906799352331291e-07 4.479300022125244 2.906799352331291e-07 C 6.266019821166992 2.906799352331291e-07 7.80866003036499 1.046430349349976 8.52793025970459 2.559600353240967 L 31.9995002746582 2.559600353240967 C 31.9995002746582 6.094800472259521 29.1338996887207 8.960400581359863 25.59959983825684 8.960400581359863 Z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2px",
    transform: "translate(791.2 551)"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "none",
    cx: 1.28,
    cy: 1.28,
    r: 1.28
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    cx: 1.28,
    cy: 1.28,
    r: 0.28
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    transform: "translate(798.24 567) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M 4.479300022125244 7.959499835968018 C 2.560309886932373 7.959499835968018 0.9991000294685364 6.398290157318115 0.9991000294685364 4.479300022125244 C 0.9991000294685364 2.560310125350952 2.560309886932373 0.9991000294685364 4.479300022125244 0.9991000294685364 L 25.59959983825684 0.9991000294685364 C 28.23563385009766 0.9991000294685364 30.43655014038086 2.897915363311768 30.90670967102051 5.399899959564209 L 8.527919769287109 5.399899959564209 L 7.896029949188232 5.399899959564209 L 7.624760150909424 5.970600128173828 C 7.050449848175049 7.178810119628906 5.815790176391602 7.959499835968018 4.479300022125244 7.959499835968018 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "none",
    d: "M 4.479299545288086 1.999100208282471 C 3.111709594726562 1.999100208282471 1.999099731445312 3.111710071563721 1.999099731445312 4.479300022125244 C 1.999099731445312 5.846889972686768 3.111709594726562 6.959500312805176 4.479299545288086 6.959500312805176 C 5.431930541992188 6.959500312805176 6.312080383300781 6.402820110321045 6.721599578857422 5.541290283203125 L 7.264150619506836 4.399899959564209 L 8.527919769287109 4.399899959564209 L 29.51833343505859 4.399899959564209 C 28.78893661499023 2.975864410400391 27.30619812011719 1.999100208282471 25.59959983825684 1.999100208282471 L 4.479299545288086 1.999100208282471 M 4.479299545288086 -0.0009002685546875 L 25.59959983825684 -0.0009002685546875 C 29.1338996887207 -0.0009002685546875 31.9995002746582 2.864699840545654 31.9995002746582 6.399899959564209 L 8.527919769287109 6.399899959564209 C 7.808649063110352 7.913069725036621 6.266019821166992 8.959500312805176 4.479299545288086 8.959500312805176 C 2.005199432373047 8.959500312805176 -0.0009002685546875 6.953400135040283 -0.0009002685546875 4.479300022125244 C -0.0009002685546875 2.005199909210205 2.005199432373047 -0.0009002685546875 4.479299545288086 -0.0009002685546875 Z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2px",
    transform: "translate(801.439 563.8) rotate(-90)"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "none",
    cx: 1.28,
    cy: 1.28,
    r: 1.28
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    cx: 1.28,
    cy: 1.28,
    r: 0.28
  })), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 3.627,
    height: 2.41,
    transform: "translate(802.293 552.35)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2px",
    d: "M-3307.032,7580h6.4",
    transform: "translate(4104.632 -7028.641)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2px",
    d: "M-3307.032,7580h6.4",
    transform: "translate(4104.632 -7024.241)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCutIcon);
export default __webpack_public_path__ + "static/media/cut-icon.0f04eded.svg";
export { ForwardRef as ReactComponent };